/**
 * Referral-code capture — single choke point per referrals-plan.md §4/§7.
 * Reads `?ref=` once per visit and persists it so any subsequent form
 * submission (via submitFormToStudio) can attach it, without every quote
 * flow needing its own wiring.
 */

const STORAGE_KEY = 'crosure_referral_code'

export function captureReferralCode(): void {
	if (typeof window === 'undefined') return
	const ref = new URLSearchParams(window.location.search).get('ref')
	if (ref && ref.trim()) {
		window.localStorage.setItem(STORAGE_KEY, ref.trim())
	}
}

export function getStoredReferralCode(): string | null {
	if (typeof window === 'undefined') return null
	return window.localStorage.getItem(STORAGE_KEY)
}
